import { render, staticRenderFns } from "./commercial-court-details.vue?vue&type=template&id=3bb84991&scoped=true&"
import script from "./commercial-court-details.vue?vue&type=script&lang=js&"
export * from "./commercial-court-details.vue?vue&type=script&lang=js&"
import style0 from "./commercial-court-details.vue?vue&type=style&index=0&id=3bb84991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb84991",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
